<template lang="pug">
  div
    h4 Selecciona columnas a exportar
    br
    el-transfer(
      class="transfer-list"
      v-model="transferData"
      :right-default-checked="checkedList"
      :titles="['No seleccionadas', 'Seleccionadas']"
      :format="format"
      :data="values"
      @change="handleChange"
    )
</template>

<script>
export default {
  name: 'TransferList',
  props: {
    data: { type: Array, default: () => [] },
    defaultColumns: { type: Array, default: () => [] },
  },
  data() {
    return {
      transferData: [],
      values: [],
      checkedList: [],
      // eslint-disable-next-line no-template-curly-in-string
      format: { noChecked: '${total}', hasChecked: '${checked}/${total}' },
    };
  },
  mounted() {
    this.initializeValues();
  },
  watch: {
    data() {
      this.initializeValues();
    },
    defaultColumns() {
      this.initializeValues();
    },
  },
  methods: {
    initializeValues() {
      this.values = this.data || [];
      this.checkedList = this.defaultColumns || [];
      this.transferData = [...this.checkedList];
    },
    handleChange(value) {
      this.$emit('handleExportList', value);
    },
  },
};
</script>

<style scoped>
.transfer-list {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}

.transfer-list ::v-deep .el-transfer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 44px;
  width: 100%;
}

.transfer-list ::v-deep .el-transfer-panel {
  width: 320px;
  height: 360px;
}

.transfer-list ::v-deep .el-transfer-panel__header {
  background-color: #f7f9fc;
}

.transfer-list ::v-deep .el-transfer__buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 360px;
  gap: 12px;
}

.transfer-list ::v-deep .el-transfer__buttons .el-button {
  margin: 0;
}
</style>
